














































































import audit_mixins from "@/mixins/audit_mixin";
import {Component, Vue} from "vue-property-decorator";

@Component({components: {}, mixins: [audit_mixins]})
export default class platform_audit extends Vue {
}
